import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Home',
    url: '/home',
    icon: 'icon-home',
  },
  {
    name: 'Profile',
    url: '/children',
    icon: 'fa fa-user-o',
  },
  // {
  //   name: '',
  //   url: '/',
  //   class: 'calandar-exception',
  //   icon: 'cil-calendar',
  //   attributes: {
  //     "calendarExceptionModal": true
  //   }

  // }

  
];
